// extracted by mini-css-extract-plugin
export var searchHeader = "_7i-0";
export var searchHeaderDark = "_7i-1";